export const VIOLATIONS_SETTING_TYPE = {
    ALLOW_OWNERS_TO_RESOLVE_VIOLATIONS: 94,
    SHARE_VIOLATIONS_BY_DEFAULT: 95,
    AUTO_EMAIL_TEMPLATE: 118,
    ATTACH_VIOLATION_DETAILS: 119,
    AUTO_GENERATE_LETTER: 124,
    AUTO_SEND_EZMAIL: 125,
    OVERRIDE_GLOBAL_SETTINGS: 130
};

export const ADD_ON_SERVICE_STATUS = {
    Enabled: 1,
    Pending: 2,
    NotEnabled: 3
};

export const ADD_ON_SERVICE_TYPE = {
    Epay: 1,
    Ezmail: 2,
    Efile1099: 3,
    RemoteCheckPrinting: 4,
    BasicTenantScreening: 5,
    PremiumTenantScreening: 6,
    RentersInsurance: 7,
    APM: 8,
    Eleasing: 9,
    PropertyInspections: 10,
    ShowingsCoordinator: 11,
    RetailCash: 12,
    PrioritySupport: 13,
    Esignature: 14,
    RealPageOpsTech: 15,
    ResidentRentReporting: 16,
    PropertyInsurance: 17,
    MaintenanceContactCenter: 18,
    BuildiumMarketplace: 19,
    SecurityDepositPartner: 20
};
